module.exports = __webpack_public_path__ + "img/book.59373a8e.svg";